(function () {

	'use strict';

	angular
		.module("portalApp")
		.controller("CountryUsersCtrl", Controller);

	/**
	 * @ngInject
	 */
	function Controller($scope, $log, $q, studyPermissionsService, studyPermissionsTrans) {

		$log = $log.getInstance("CountryUsersCtrl", "color:purple");
		$log.debug("CountryUsersCtrl:: loaded");

		var vm = this;

		vm.dataLoading = true;
		vm.loadingError = '';
		vm.model = {};
		vm.options = {};
		vm.errorMsg = "";
		vm.localized = {
			gridColumns: {},
			list: {}
		};
		$scope.$parent.loadGridData = loadGridData;
		vm.confirmHandler = {
			showDialog: false
		};
		vm.gridOptions = {
			rowDefs: {},
			sortOrders: [
				{
					fieldName: 'fullName',
					reverseOrder: false
				}
			],
			gridActions: [],


			getData: function (options) {
				return $q(function (resolve, reject) {
					loadData(options, resolve, reject);
				});
			}
		};
		activate();

		function activate() {
			studyPermissionsTrans.getListViewLocalized().then(function (localized) {
				vm.localized = localized;

				vm.gridOptions.columnDefs = [
					{
						displayName: localized.gridColumns.userName,
						fieldName: 'fullName',
						isSortable: true,
						type: 'string',
						isDefaultFilter: true
					},
					{
						displayName: localized.gridColumns.userEmail,
						fieldName: 'personEmail',
						isSortable: true,
						type: 'string'
					},
					{
						displayName: localized.gridColumns.accountCreated,
						fieldName: 'userCreatedDate',
						isSortable: true,
						type: 'date',
						formatter: 'dateTimeFormatNA'
					},
					{
						displayName: localized.gridColumns.roles,
						fieldName: 'userRoles',
						removeSortControls: true,
						type: 'string'
					},
					{
						displayName: localized.gridColumns.country,
						fieldName: 'countryName',
						isSortable: true,
						type: 'string'
					},
					{
						displayName: localized.gridColumns.lastLogon,
						fieldName: 'lastLoginDate',
						isSortable: true,
						type: 'date',
						formatter: 'dateTimeFormat'
					},
					{
						displayName: localized.gridColumns.portalAccount,
						fieldName: 'isPortalAccountEnabled',
						isSortable: true,
						type: 'enum',
						formatter: 'yesNo',
						enumType: 'bool',
						enums: [{
							displayName: 'Yes',
							values: [1]
						}, {
							displayName: 'No',
							values: [-1]
						}]
					}
				];

				vm.gridOptions.gridRowActions = [];
				loadGridData();
			});
		}

		function loadGridData(reload) {
			vm.load = true;
		}

		function loadData(options, resolve, reject) {
			vm.dataLoading = true;
			vm.loadingError = '';
			studyPermissionsService.getCountryUsers(options)
				.then(function (response) {
					vm.gridOptions.gridRowActions = [];

					vm.model = response.data.model;
					vm.options.config = response.data.config;
					if (vm.options.config.allowRequestRemovalOnCountry === true) {
						vm.gridOptions.gridRowActions.push(
							{
								displayName: vm.localized.buttons.removeUser,
								enabledIfFieldName: 'allowRequestRemoval',
								action(row) {
									studyPermissionsService.goToCountryUserDelete(row.countryId, row.userId);
								},
								iconCssClass: 'es-icon-function-delete'
							});
					}
					if (vm.options.config.allowEditOnCountry === true) {
						vm.gridOptions.gridRowActions.push(
							{
								displayName: vm.localized.buttons.editUser,
								enabledIfFieldName: 'allowEdit',
								action(row) {
									studyPermissionsService.goToCountryUserEdit(row.countryId, row.userId);
								},
								iconCssClass: 'es-icon-user-name'
							}
						);
					}
					vm.dataLoading = false;
					resolve(vm.model);
				}, function (error) {
					vm.loadingError = error.data.message || error.data;
					reject(vm.loadingError);
				});
		}
	}
})();
